module.exports = __webpack_public_path__ + "img/look15.c99912ae.png";